import React from 'react'
import Chart from 'react-apexcharts'
import { COLORS } from './chart.constant'

const BasicColumn = ({ height = 300, width = "100%" }) => {
    const data = [
        {
            name: 'Orlando',
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
        },
        {
            name: 'New York City',
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
        },
        {
            name: 'Brooklyn',
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
        },
    ]

    return (
        <Chart
            options={{
                chart: {
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                    },
                },
                colors: COLORS,
                dataLabels: { enabled: false },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent'],
                },
                xaxis: {
                    categories: ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
                },
                fill: { opacity: 1 },
                tooltip: {
                    y: { formatter: (val) => `${val} thousands` },
                },
            }}
            series={data}
            height={height}
            width={width}
            type="bar"
        />
    )
}

export default BasicColumn